export default __webpack_public_path__ + "static/media/manifesto-bg.e702d9a6.jpg";